import React, { useState } from "react";
import { loginUser } from "../../api"; // adjust path based on folder structure
import { useNavigate } from "react-router-dom";

const Login = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    email: "",
    password: "", 
  });

  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  let user_type = "";
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await loginUser(form);
      setMessage(`✅ Welcome ${res.data.user.F_name} ${res.data.user.L_name}!`);
      // Save token or user info in localStorage if backend returns token
      if (res.data.user) {
        localStorage.setItem("user", JSON.stringify(res.data.user));
        user_type = res.data.user.user_type;
        localStorage.setItem("account_type", res.data.user.user_type);
      }
      // Redirect to dashboard (or home page)
      setTimeout(() => {
        if(user_type === 'admin'){
          navigate("/admin/dashboard");
        }else{
          navigate("/dashboard");
        }
      }, 1000);
    } catch (err) {
      setMessage(`❌ ${err.response?.data?.message || "Invalid credentials"}`);
    }
  };

  return (
    <div id="wrapper">
      <div id="page">
        <div className="sign-in-wrap">
          <div className="sign-in-box">
            <div className="left">
              <div className="content">
                <h3 className="heading">Hello 👋</h3>
                <div className="sub f12-regular text-GrayDark">
                  Welcome again to our website
                </div>

                <div className="sign-in-inner">
                  <h4>Sign In Here</h4>

                  <form
                    className="form-login flex flex-column gap24"
                    onSubmit={handleSubmit}
                  >
                    <fieldset className="email">
                      <div className="f14-regular mb-6">Email</div>
                      <input
                        type="email"
                        name="email"
                        placeholder="Enter your email"
                        value={form.email}
                        onChange={handleChange}
                        required
                      />
                    </fieldset>

                    <fieldset className="password">
                      <div className="f14-regular mb-6">Password</div>
                      <input
                        type="password"
                        name="password"
                        placeholder="Enter your password"
                        value={form.password}
                        onChange={handleChange}
                        required
                      />
                    </fieldset>

                    <button
                      type="submit"
                      className="tf-button style-1 label-01 w-100"
                    >
                      Sign In
                    </button>
                  </form>

                  {message && <p>{message}</p>}

                  <div className="f14-regular">
                    Don’t have an account?{" "}
                    <a href="/register" className="f14-bold">
                      Sign Up
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="right">
              <img src="images/item/bg-sign-in.jpg" alt="" />
              <div className="text">
                <img src="images/item/sign-in.png" alt="" />
                <h3 className="mb-24 text-White">
                  Buy & sell Each Digital <br /> Cryptocurrency
                </h3>
                <div className="f14-regular text-White">
                  Easily Buy bitcoin and other cryptocurrencies using <br />
                  wide range of payment option. Discover exclusive <br />
                  digital collection of us.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
